export type Locale = 'en' | 'fr';

/**
 * Dictionnaire français : les clés sont les chaînes anglaises affichées dans l'UI.
 * Les valeurs des <option> envoyées à l'API (ex: "Give to someone") et les messages
 * d'erreur renvoyés par le backend ne sont PAS concernés : ils ne passent jamais par t().
 */
const fr: Record<string, string> = {
    // Messages d'état générés côté client
    'Invalid OAuth state. Please try again.': 'État OAuth invalide. Veuillez réessayer.',
    'Scan succeeded': 'Scan réussi',
    'QR code not allowed.': 'QR code non autorisé.',
    'Error creating person:': 'Erreur lors de la création de la personne :',
    'Error creating person': 'Erreur lors de la création de la personne',
    'Action submitted': 'Action soumise',
    'Error:': 'Erreur :',
    'Are you connected to the VPN?': 'Êtes-vous connecté au VPN ?',
    'Connection error. Please check your network.': 'Erreur de connexion. Veuillez vérifier votre réseau.',
    'Please select an option': 'Veuillez sélectionner une option',

    // Interface
    'Sign in with Google': 'Se connecter avec Google',
    'Loading...': 'Chargement...',
    'Logout': 'Déconnexion',
    'Start scanning': 'Commencer le scan',
    'Cancel': 'Annuler',
    'Identifier:': 'Identifiant :',
    'Choose an action:': 'Choisissez une action :',
    'Choose': 'Choisir',
    'Deposit in the safe': 'Déposer dans le coffre',
    'Take out from the safe': 'Retirer du coffre',
    'Give to someone': 'Donner à quelqu’un',
    'Give back to customer': 'Rendre au client',
    'Person:': 'Personne :',
    'Select a person': 'Sélectionner une personne',
    '+ Create new person': '+ Créer une nouvelle personne',
    'First name *': 'Prénom *',
    'Last name *': 'Nom *',
    'Phone (ex: +33611223344)': 'Téléphone (ex : +33611223344)',
    'Staff Member': 'Membre du personnel',
    'Additional Info:': 'Informations supplémentaires :',
    'Submit': 'Valider',
    'Close': 'Fermer',
    'Add to Home Screen (Safari only) 🚀': 'Ajouter à l’écran d’accueil (Safari uniquement) 🚀',
    'Tap the Share button, then "Add to Home Screen". (Safari only)':
        'Appuyez sur le bouton Partager, puis sur « Ajouter à l’écran d’accueil ». (Safari uniquement)',
};

// L'anglais est la langue de référence : les clés sont déjà les chaînes anglaises.
const en: Record<string, string> = {};

const dictionaries: Record<Locale, Record<string, string>> = {en, fr};

/**
 * Traduit une clé (chaîne anglaise) dans la locale demandée.
 * Retombe sur l'anglais (la clé elle-même) si la clé ou l'entrée manque.
 */
export function t(locale: Locale, key: string): string {
    return dictionaries[locale]?.[key] ?? dictionaries.en[key] ?? key;
}
